import React, { FC } from 'react'
import { numberFormatter } from 'helpers'
import './packageDiscountPriceBar.scss'

type PackageDiscountPriceBarProps = {
    listTotal: number
    discount: number
    netTotal: number
    hidePrice?: boolean
}

export const PackageDiscountPriceBar: FC<PackageDiscountPriceBarProps> = ({
    listTotal,
    discount,
    netTotal,
    hidePrice = false
}) => {
    const showChip = discount > 0 && !hidePrice

    return (
        <div
            className={`package-discount-price-bar ${
                showChip ? 'package-discount-price-bar--with-discount' : ''
            }`}
            data-testid="package-discount-price-bar"
        >
            {showChip && (
                <div
                    className="package-discount-price-bar__chip"
                    data-testid="package-discount-chip"
                >
                    -{numberFormatter(discount, 'CFA')}
                </div>
            )}
            <div
                className="package-discount-price-bar__net"
                data-testid="package-discount-net-total"
            >
                {numberFormatter(netTotal, 'CFA', hidePrice)}
            </div>
            {/* listTotal kept for callers/tests; not shown when chip+net match Figma */}
            <span className="sr-only" data-testid="package-discount-list-total">
                {listTotal}
            </span>
        </div>
    )
}
